import { render, staticRenderFns } from "./Topupplan.vue?vue&type=template&id=2b6a22b6&scoped=true&"
import script from "./Topupplan.vue?vue&type=script&lang=js&"
export * from "./Topupplan.vue?vue&type=script&lang=js&"
import style0 from "./Topupplan.vue?vue&type=style&index=0&id=2b6a22b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6a22b6",
  null
  
)

export default component.exports